import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser, clearError, clearSuccessMessage, clearErrors } from '../../store/slices/authSlice';
import banner from '../../assets/img/pexels-earano-1683802.jpg'
import Logo from '../../components/Logo'
import Input from '../../components/fields/Input'
import ButtonLightBlue from '../../components/buttons/ButtonLightBlue';
import { ErrorMessage } from '../../components/messages/success';
import GuestHeader from '../../layout/GuestHeader'
import Footer from '../../layout/Footer';
import {Helmet} from "react-helmet";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading, error, token, errors } = useSelector((state) => state.auth);
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  useEffect(() => {
    if (token) {
      navigate('/');
    }
  }, [token, navigate]);

  useEffect(() => {
    if (error && error === 'Email not verified') {
      dispatch(clearError());
      navigate('/verify');
    }
  }, [error, navigate, dispatch]);

  useEffect(() => {
    dispatch(clearError());
    dispatch(clearErrors());
    dispatch(clearSuccessMessage());
  }, [dispatch]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(loginUser(formData));
  };

  const renderErrorMessages = () => {
    return Object.entries(errors).map(([field, messages]) => (
      <ErrorMessage key={field} message={`${messages.join(', ')}`} />
    ));
  };

  return (
    <>
      <Helmet>
          <title>Log In | Oreca Pro</title>
          <link rel="canonical" href={window.location.href} />
      </Helmet>
      <GuestHeader />
      <section
        style={{ backgroundImage: `url(${banner})` }}
        className='guest-section relative bg-center bg-cover'
      >
        <div 
          className='absolute inset-0'
          style={{
            background: 'linear-gradient(180deg,rgba(16, 28, 34, 0) 0%, rgba(16, 28, 34, 0.15) 46%, rgba(16, 28, 34, 0.84) 55%, rgba(16, 28, 34, 1) 64%)'
          }}
        />
        <div className='w-full max-w-[340px] relative mx-auto text-center px-4 pt-[120px] md:pt-[160px]'>
          <div className='scale-[1.4] my-5'>
            <Logo />
          </div>
          <h1 className='text-3xl font-semibold my-5'>Log In</h1>
          <p className='mt-5 mb-7 font-normal'>Log in or sign up to get started with orca, your personalized surf forecast</p>

          <form onSubmit={handleSubmit}>
              {error && <ErrorMessage message={error} />}
              {renderErrorMessages()}
              <Input 
                id="email" 
                type="email" 
                name="email" 
                value={formData.email} 
                placeholder='Email' 
                onChange={handleInputChange}
              />
              <Input 
                id="password" 
                type="password" 
                name="password" 
                value={formData.password} 
                placeholder='Password' 
                onChange={handleInputChange}
              />
              <Link to="/password-reset" className='text-custom-light-blue text-left block my-5'>Forgot password?</Link>
              <ButtonLightBlue 
                type="submit" 
                className='font-semibold text-center block bg-custom-light-blue text-white border-custom-custom-light-blue rounded-md w-full min-h-[45px]'
                disabled={isLoading}
                text={isLoading ? 'Logging In...' : 'Log In'}
              />
          </form>
          <p className='mt-7'>Don't have an account? <Link to="/register" className='text-custom-light-blue font-semibold'>Sign up</Link></p>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Login;
